<mat-form-field
  class="fw slimline merge-match-downdown"
  [ngClass]="{
    'focus-border':
      showFocusBorderIfMergeCandidate &&
      !hasInteractedWithDropdown &&
      selectedOption.includes(UpdatePropertyOption.MergeProperty)
  }">
  <mat-select [(ngModel)]="selectedOption" (ngModelChange)="selectedOptionChange($event)">
    <mat-select-trigger *ngIf="selectedOption" class="relative top-0.5">
      <div
        *ngIf="selectedOption === UpdatePropertyOption.CreateNewProperty"
        fxLayoutGap="8px"
        fxLayoutAlign="start center">
        <sbnb-icon fxFlex="0 0 24px" icon="properties" class="select-trigger__icon"></sbnb-icon>
        <span class="ellipsis">Import property</span>
      </div>

      <div *ngIf="selectedOption === UpdatePropertyOption.MuteProperty" fxLayoutGap="8px" fxLayoutAlign="start center">
        <sbnb-icon fxFlex="0 0 24px" icon="alarm-bell-off" class="select-trigger__icon"></sbnb-icon>
        <span class="ellipsis">Mute this property on Hospitable.com</span>
      </div>

      <div
        *ngIf="selectedOption === UpdatePropertyOption.UnmuteProperty"
        fxLayoutGap="8px"
        fxLayoutAlign="start center">
        <sbnb-icon fxFlex="0 0 24px" icon="alarm-bell-check" class="select-trigger__icon"></sbnb-icon>
        <span class="ellipsis">Unmute this property on Hospitable.com</span>
      </div>

      <div
        *ngIf="selectedOption.includes(UpdatePropertyOption.MergeProperty) && properties?.length > 0"
        fxLayoutGap="8px"
        fxLayoutAlign="start center">
        <ng-container
          *ngIf="propertyEntities && propertyEntities[selectedOption.replace(UpdatePropertyOption.MergeProperty, '')]">
          <sbnb-icon fxFlex="0 0 24px" icon="hyperlink" class="select-trigger__icon"></sbnb-icon>
          <!-- <img
            fxFlex="0 0 24px"
            class="select-trigger__property-image"
            [src]="propertyEntities[selectedOption.replace(UpdatePropertyOption.MergeProperty, '')].picture" /> -->
          <span class="ellipsis">
            {{ propertyEntities[selectedOption.replace(UpdatePropertyOption.MergeProperty, '')].name }}
          </span>
        </ng-container>
      </div>
    </mat-select-trigger>

    <mat-option
      *ngIf="properties && properties.length > 0 && selectedOption.includes(UpdatePropertyOption.MergeProperty)">
      <ngx-mat-select-search
        ngModel
        (ngModelChange)="filterProperties($event)"
        placeholderLabel="Search by name or address..."
        noEntriesFoundLabel="No properties found"></ngx-mat-select-search>
    </mat-option>

    <mat-option [value]="UpdatePropertyOption.CreateNewProperty">
      <div class="flex gap-1 items-center">
        <sbnb-icon icon="properties"></sbnb-icon>
        <span>Import property</span>
      </div>
    </mat-option>

    <mat-option [value]="UpdatePropertyOption.MuteProperty" *ngIf="!isMuted">
      <sbnb-icon icon="alarm-bell-off"></sbnb-icon>
      Mute this property on Hospitable.com
    </mat-option>

    <mat-option [value]="UpdatePropertyOption.UnmuteProperty" *ngIf="isMuted">
      <sbnb-icon icon="alarm-bell-check"></sbnb-icon>
      Unmute this property on Hospitable.com
    </mat-option>

    <ng-container *ngIf="properties && properties.length > 0">
      <ng-container
        *ngIf="
          properties.length === 1 && hidePropertiesWithIds.indexOf(properties[0].id) !== -1;
          else syncActionTemplate
        "></ng-container>
      <ng-template #syncActionTemplate>
        <mat-optgroup *ngIf="false">
          <sbnb-icon icon="hyperlink"></sbnb-icon>

          Sync with existing property:
          <ng-container *ngFor="let prop of filteredProperties">
            <ng-container *ngIf="!hidePropertiesWithIds || hidePropertiesWithIds.indexOf(prop.id) === -1">
              <mat-option [value]="UpdatePropertyOption.MergeProperty + prop.id">
                <div fxLayoutGap="8px" fxLayoutAlign="start center">
                  <img fxFlex="0 0 40px" class="select-option__property-image" [src]="prop.picture" />
                  <div class="select-option__text ellipsis">
                    {{ prop.name }}
                    <br />
                    {{ prop.address }}
                    <br />
                    {{ prop.platform }}
                  </div>
                </div>
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-optgroup>
      </ng-template>
    </ng-container>
  </mat-select>
</mat-form-field>

<div *ngIf="selectedOption.includes(UpdatePropertyOption.MergeProperty)" class="text-xs text-right text-smoke-darker">
  We'll add this new listing to your existing property.
</div>
